import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { retreive } from "../../actions/order";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Moment from "react-moment";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
class RewardPoint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: null,
    };
  }
  async componentDidMount() {
    const orders = await this.props.retreive();
    window.scrollTo(0, 0);
    if (orders) {
      this.setState({ orders: orders.reverse() });
    }
  }
  render() {
    const { isAuth, user } = this.props._auth;
    return (
      <Fragment>
        <div className="reward-wrapper wrapper-90 max-1600">
          <ul className="breadcrumb">
            <li>
              <Link to="/">
                <i className="fa fa-home" />
              </Link>
            </li>
            <li>
              <Link to="/dashboard"> / Account</Link>
            </li>
            <li>
              <Link to="/reward-points"> / Reward Points</Link>
            </li>
          </ul>
          <div className="container-fluid">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9">
                <header className="reward-point-header">
                  <h3 className="reward-point-title">Reward Point</h3>
                  <p>
                    Your total number of reward points is:{" "}
                    {user && Number(user.rewardPoints).toFixed(2)}
                  </p>
                </header>
                <div className="reward-table">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr className="reward-tbl-header">
                          <th scope="col">
                            <div className="text-center">Date</div>
                          </th>
                          <th scope="col">
                            <div className="text-center">Amount</div>
                          </th>
                          <th scope="col">
                            <div className="text-center">
                              <span>Reward Point</span>
                            </div>
                          </th>
                          <th scope="col">
                            <div className="text-center">
                              <span>Transaction Details</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.orders &&
                          this.state.orders.length > 0 &&
                          this.state.orders.map((item, index) =>
                            item.rewardPoints && item.rewardPoints > 0 ? (
                              <tr key={index} className="reward-tbl-body">
                                <td className="reward-td">
                                  <div className="reward-date text-center">
                                    <span className="m-0">
                                      <Moment format="DD/MM/YYYY">
                                        {item.createdAt}
                                      </Moment>
                                    </span>
                                  </div>
                                </td>
                                <td className="reward-td">
                                  <div className="reward-discriptions text-center">
                                    <span>
                                      {Number(item.amount).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                                <td className="reward-td">
                                  <div className="reward-p-name text-center">
                                    <span>
                                      {Number(item.rewardPoints).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                                <td className="reward-td">
                                  {item.items.map((product, ind) => (
                                    <Fragment key={ind}>
                                      <ul>
                                        <li>
                                          <b>product Name</b> :
                                          {product && product.item.title}
                                        </li>
                                      </ul>
                                      <ul>
                                        <li>
                                          <b>Price</b> :
                                          {Number(product.item.price).toFixed(
                                            2
                                          )}
                                        </li>
                                      </ul>
                                      <ul>
                                        <li>
                                          <b>Quantity</b> :{product.quantity}
                                        </li>
                                      </ul>
                                    </Fragment>
                                  ))}
                                </td>
                              </tr>
                            ) : (
                              <Fragment key={index}></Fragment>
                            )
                          )}
                        {this.state.orders && this.state.orders.length === 0 ? (
                          <tr className="text-center">
                            <td colSpan="4">
                              <b>You don't have rewards history yet</b>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

retreive.propTypes = {
  editNewsretreiveletter: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { retreive })(RewardPoint);
